import styled from "styled-components";

export const SearchContainer = styled.div`
  width: 30%;
  height: 40px;
  flex-shrink: 0;
`;

export const StyledButtons = styled.div`
  .buttons-wrapper {
      width: 100%;
      display: flex;
      gap: 10px;
      margin-left: 3px;
      flex-wrap: wrap;
      margin-bottom: 10px;
      flex-direction: row;
      
      @media screen and (max-width: 800px) {
          flex-direction: column;
      }
  }
    
    .button-toolbar-group
    {
        width: 17em;
    }
`;
